// There is no implementation of deep clone in Vue and javascript! Google it!
export default function deepClone(object) {
  return JSON.parse(JSON.stringify(object));
}
